import React, { Component } from "react";
import { Row, Column } from "react-foundation";
import Cart from "components/Cart";

import "css/ItemSelectorPage.css";

import iconWindow from "images/icon-window.svg";
import iconDoor from "images/icon-door.svg";
import iconConservatory from "images/icon-conservatory.svg";
import iconAdditional from "images/icon-additional.svg";
import bgDoor from "images/bg-door.jpg";
import bgWindow from "images/bg-windows.jpg";
import bgConservatory from "images/bg-conservatories.jpg";
import bgAdditional from "images/door@2x.png";
import { connect } from "react-redux";
import Logo from "./../components/Logo";
import { getProductSuites } from "actions";
import ItemSelectorItem from "../components/ItemSelectorItem";
import ItemSelectorTab from "../components/ItemSelectorTab";

class ItemSelectorPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedItem: "Windows"
        };
    }

    componentWillMount(){
        this.props.getProductSuites();
    }

    getColumnOffset(i, productSuites){
        let offset = productSuites === 2 && i === 0 ? 2 : 0;
        if(productSuites === 1){ offset = 4; }
        return offset;
    }

    render() {
        const { ProductSuites } = this.props;
        var customerColour = "#CF122F";
        let columnSize = ProductSuites.length === 2 ? 4 : 12 / ProductSuites.length

        if (this.props.Customer) {
            customerColour = this.props.Customer.Colour;
        }

        const isMobile = window.innerWidth < 640;

        const itemTypes = [
            {type: "WINDOWS", icon: iconWindow, bgImage: bgWindow, name: "Windows", to:"Window", caption: "Let the light in"},
            {type: "DOORS", icon: iconDoor, bgImage: bgDoor, name: "Doors", to:"Door", caption: "The gateway to your home"},
            {type: "CONSERVATORIES", icon: iconConservatory, bgImage: bgConservatory, name: "Conservatory", to:"Conservatory", caption: "Create more space"},
            {type: "ADDITIONAL PRODUCTS", icon: iconAdditional, bgImage: bgAdditional, name: "Additional", to:"Additional", caption: "Anything else you need"}
        ];
        
        return (
            <div className="ItemSelector">
                <Cart />
                <Row>
                    <Column small={12} medium={8} large={6} centerOnSmall>
                        <p className="title">
                            <Logo
                                className="show-for-small-only"
                                topLeft={false}
                                vertical={false}
                            />
                            <Logo className="show-for-medium" topLeft={false} vertical={true} />
                        </p>
                        <h3 className="user-prompt">Get your personalised quote in minutes</h3>
                        <p className="user-choice">Choose the product you would like a quote for</p>
                    </Column>
                </Row>
                <Row showOnlyFor="small" className="item-tabs item-tabs-top">
                    <Column small={12}>
                        <ItemSelectorTab
                            name="Windows"
                            type="WINDOWS"
                            selected={this.state.selectedItem}
                            onClick={newState => this.setState(newState)}
                            background={bgWindow}
                            ProductSuites={ProductSuites}
                            customerColour={customerColour}
                            loading={this.props.Loading}
                        />
                        <ItemSelectorTab
                            name="Doors"
                            type="DOORS"
                            selected={this.state.selectedItem}
                            onClick={newState => this.setState(newState)}
                            background={bgDoor}
                            ProductSuites={ProductSuites}
                            customerColour={customerColour}
                            loading={this.props.Loading}
                        />
                        <ItemSelectorTab 
                            name="Conservatory" 
                            type="CONSERVATORIES"
                            selected={this.state.selectedItem} 
                            onClick={newState => this.setState(newState)} 
                            background={bgConservatory}
                            ProductSuites={ProductSuites}
                            customerColour={customerColour}
                            loading={this.props.Loading}
                        />
                        <ItemSelectorTab 
                            name="Additional" 
                            type="ADDITIONAL PRODUCTS"
                            selected={this.state.selectedItem} 
                            onClick={newState => this.setState(newState)} 
                            background={bgAdditional}
                            ProductSuites={ProductSuites}
                            customerColour={customerColour}
                            loading={this.props.Loading}
                        />
                    </Column>
                </Row>
                <Row className="item-panel-container">
                    {
                        itemTypes.map((item, i) => {
                            return(
                                <ItemSelectorItem
                                    key={i}
                                    ProductSuites={ProductSuites} 
                                    type={item.type}
                                    icon={item.icon}
                                    to={item.to}
                                    name={item.name} 
                                    bgImage={item.bgImage} 
                                    customerColour={customerColour} 
                                    columnSize={ProductSuites.length === 1 ? 4: columnSize} 
                                    offset={this.getColumnOffset(i, ProductSuites.length)}  
                                    isMobile={isMobile}
                                    loading={this.props.Loading}
                                    selectedItem={this.state.selectedItem}
                                    caption={item.caption}
                                />
                            );
                        })
                    }
                </Row>
            </div>
        );
    }
}

const mapStateToProps = state => {
    let loading = true;
    if(state.ItemSelector[0] !== undefined){
        loading = false;
    }

    return {
        Customer: state.TradeCustomer,
        ProductSuites: state.ItemSelector,
        Loading: loading,
    };
};

export default connect(mapStateToProps, { getProductSuites })(ItemSelectorPage);



// WEBPACK FOOTER //
// ./src/containers/ItemSelectorPage.js